import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Edit2, CheckCircle } from "lucide-react";

export const BulkPartyModal = ({
  bulkPartyModal,
  setBulkPartyModal,
  bulkPartyName,
  setBulkPartyName,
  bulkPan,
  setBulkPan,
  handleBulkPartyUpdate,
  selectedTxns,
}) => {
  const close = () => setBulkPartyModal({ open: false });
  return (
    <Dialog open={bulkPartyModal.open} onOpenChange={(open) => !open && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit2 className="w-5 h-5" />
            Update Party Name/PAN
          </DialogTitle>
          <DialogDescription>
            Update party name and/or PAN for {selectedTxns.size} selected transaction(s)
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> This will update the selected {selectedTxns.size} transaction(s).
              Leave a field empty to keep the existing value.
            </p>
          </div>
          <div>
            <Label className="text-sm font-medium">New Party Name</Label>
            <Input
              value={bulkPartyName}
              onChange={(e) => setBulkPartyName(e.target.value)}
              placeholder="Enter new party name (optional)"
              className="mt-2"
              data-testid="bulk-party-name-input"
            />
          </div>
          <div>
            <Label className="text-sm font-medium">New PAN</Label>
            <Input
              value={bulkPan}
              onChange={(e) => setBulkPan(e.target.value.toUpperCase())}
              placeholder="Enter new PAN (optional)"
              maxLength={10}
              className="mt-2 font-mono uppercase"
              data-testid="bulk-pan-input"
            />
            <p className="text-xs text-slate-500 mt-1">
              4th character determines entity type: P=Individual, C=Company, F=Firm, H=HUF
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="bulk-party-cancel-btn">Cancel</Button>
          <Button onClick={handleBulkPartyUpdate} disabled={!bulkPartyName && !bulkPan} data-testid="bulk-party-confirm-btn">
            <CheckCircle className="w-4 h-4 mr-2" />
            Update {selectedTxns.size} Transaction(s)
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
